import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDateTimeToDate',
})
export class ConvertDateTimeToDatePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      let val = new Date(value).toLocaleDateString();
      if (val) {
        return val;
      } else {
        return 'Invalid Date';
      }
    } else {
      return 'Date not found';
    }
  }
}
